export const USERS = "/api/users"
export const USER = "/api/user/:param"

export const USER_ACTIVATE = "/api/user/:param/activate"
export const USER_DEACTIVATE = "/api/user/:param/deactivate"

export const USER_DELETE = "/api/user/:param/delete"
export const USER_UNDELETE = "/api/user/:param/undelete"

export const USERS_ACTIVATE = "/api/users/activate"
export const USERS_DEACTIVATE = "/api/users/deactivate"

export const USERS_UNDELETE = "/api/users/undelete"
export const USERS_DELETE = "/api/users/delete"

export const REGENRATE_PASSWORD = "/api/user/:param/generate-password"
